






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { JsonServiceClient, toFormData } from '@servicestack/client';
import { redirect, Routes } from '../../shared/router';
import { bus, store, client, getUserInfo } from '../../shared';
import { UserInfo } from '../../shared/user';
import {
  GrantBase,
  Grants,
} from '../../shared/study';
import moment from 'moment';
import _ from 'lodash';
import { euCountries, nonUSCountries } from '../../shared/constants';
@Component({
  components: {},
})
export default class StudySubmission extends Vue {
  activeSession: any = {};
  title = 'Islet/Biospecimen Study Submission';
  subtitle = 'Your Islet/Biospecimens Study submission details are as follows.';
  iidpIsletStudyDashboard: any = '';
  iidpDataStudyDashboard: any = '';
  euCountries: any = euCountries;
  nonUSCountries: any = nonUSCountries;
  isEUCountry: boolean = false;
  form: any = {
    userId: '',
    rowId: 0,
    non_Profit: false,
    peer_Rev_Grant: false,
    fundsAva: false,
    firstName: '',
    lastName: '',
    middleInitial: '',
    pI_Email: '',
    institution: '',
    title: '',
    pI_Phone: '',
    pI_Phone_Ext: '',
    textMsg: false,
    pI_Cell: '',
    provider_ID: '',
    pI_Address_1: '',
    pI_Address_2: '',
    pI_City: '',
    country: '',
    pI_Zip: '',
    pI_State: '',
    pI_State_Oth: '',
    pI_Province: '',
    time_Zone: '',
    timeZoneOther: '',
    wKShipment: false,
    shippingNote: '',
    sameasMailing: false,
    shipCountry: '',
    ship_Addr_1: '',
    ship_Addr_2: '',
    ship_City: '',
    ship_State: '',
    ship_Province: '',
    ship_State_Oth: '',
    ship_Zip: '',
    wK_Contact: '',
    wkShipCountry: '',
    wK_Ship_Addr_1: '',
    wK_Ship_Addr_2: '',
    wK_Ship_City: '',
    wK_Ship_State: '',
    wK_Ship_Province: '',
    wK_Ship_State_Oth: '',
    wK_Ship_Zip: '',
    wK_Phone: '',
    listScientists: '',
    pIconsulted: false,
    pIagreement: false,
    consulted: false,
    policies: false,
    allNonProfit: false,
    coPIReason: '',
    study_Title: '',
    projAbstract: '',
    researchMethods: '',

    culturedIslets: false,
    isletsReqReason: '',
    frozenIslets: false,
    rationaleAcinar: '',
    rationaleFrozen: '',
    histoSlides: false,
    rationaleHistoSlides: '',
    rationaleBlood: '',
    rationaleAncillary: '',
    acinar: false,
    bloodProd: false,
    serum: false,
    plasma: false,
    ancillary: false,
    lymphNode: false,
    spleen: false,
    duodenum: false,
    ductal: false,
    frozenPancreaticPcs: false,
    iacuC_Status: '',
    iacuC_App_No: '',
    iacuC_App_Dt: '',
    cellStimulus: false,
    cellDeath: false,
    type1Diabetes: false,
    tissueEngineering: false,
    alphaCells: false,
    geneticsGenomics: false,
    otherArea: false,
    otherAreaText: '',
    comp_Dt: '',
    ieQs_Ideal: '',
    ieQs_Min: '',
    purity_Ideal: '',
    purity_Min: '',
    viability_Ideal: '',
    viability_Min: '',
    freq_Ideal: '',
    freq_Min: '',
    tot_IEQs_Needed: '',
    cultured_Ideal: '',
    cultured_Min: '',
    diabetic_Ideal: '',
    diabetic_Min: '',
    web: false,
    wom: false,
    ad: false,
    meeting: [],
    meetingOther: '',
    meetingSpecify: '',
    otherS: false,
    otherS_text: '',
   hasORCID: false,
    rsnNoORCID: '',
    orcid: '',
    cultureLen: false,
    cultureMinDay: '',
    cultureMinHr: '',
    cultureMaxDay: '',
    cultureMaxHr: '',
    typeofStudy: '',
    moved: false,
    role: '',
    grants: [],
    degrees: [],
      degreeOther: '',
      referrals: [],
      referralOther: '',
    animalResearch: false,
    urn: '',
  };
  grantList: GrantBase[] = [];

  get userInfo() {
    return store.userInfo;
  }
  get userSession() {
    return store.userSession;
  }
  get isEU() {
    const items = this.euCountries.filter(
      (item: any) => item.value === this.form.country,
    );
    const items2 = this.euCountries.filter(
      (item: any) => item.value === this.form.shipCountry,
    );
    const items3 = this.euCountries.filter(
      (item: any) => item.value === this.form.wKShipCountry,
    );
    if (items.length > 0 || items2.length > 0 || items3.length > 0) {
      this.isEUCountry = true;
      this.$emit('eu-country-changed', true);
      return true;
    } else {
      this.isEUCountry = false;
      this.$emit('eu-country-changed', false);
      return false;
    }
  }
  async created() {
    if (Object.keys(this.userInfo).length === 0) {
      const u = this.userSession!.userName;
      if (u !== undefined && u !== null) {
        const d = await client.get(new UserInfo({ userName: u }));
        bus.$set(store, 'userInfo', d);
        bus.$emit('userInfo', d);
        if (
          this.userInfo.study !== undefined &&
          this.userInfo.study.form !== undefined
        ) {
          Object.assign(this.form, this.userInfo.study.form);
        }
      }
    }
    if (
      this.userInfo.study !== undefined &&
      this.userInfo.study.form !== undefined
    ) {
      setTimeout(() => {
        Object.assign(this.form, this.userInfo.study.form);
      }, 2000);
    }
    }

  loadToForm() {
    bus.$on('userInfo', (payload: any) => {
      Object.assign(this.form, payload.study.form);
      this.activeSession = JSON.parse(
        localStorage.getItem(this.userInfo.userInfo.userName) || '{}',
      );
      if (!_.isEmpty(this.activeSession)) {
        this.form.personId = this.activeSession.personId;
        }
    });
  }
  activated() {
    if (
      this.userInfo.study !== undefined &&
      this.userInfo.study.form !== undefined
    ) {
      Object.assign(this.form, this.userInfo.study.form);
    }
  }
  mounted() {
    this.loadToForm();
    this.loadDegrees();
    const iidpSecureUrl = IIDPconfig.SECURE_URL as string;
    this.iidpIsletStudyDashboard = `${iidpSecureUrl}/${IIDPconfig.ISLET_STUDY_DASHBOARD as string}`;
    this.iidpDataStudyDashboard = `${iidpSecureUrl}/${IIDPconfig.DATA_STUDY_DASHBOARD as string}`;
  }
  dateConverter(d: any) {
    return moment.utc(d).format('MM/DD/YYYY');
  }
  format_date(value: any) {
    if (value) {
      return moment(String(value)).format('MM/DD/YYYY');
    }
  }
  loadDegrees() {
      this.form.degrees = this.userInfo.study.degreeList;
      this.form.referrals = this.userInfo.study.referalList;
  }
}
